import $ from "jquery";

class Dropdown {
  constructor(element) {
    this.instance = $(element);
  }

  onHide(callback) {
    this.instance.on("hidden.bs.dropdown", callback);
  }

  onShow(callback) {
    this.instance.on("shown.bs.dropdown", callback);
  }

  dispose() {
    this.instance.dropdown('dispose')
  }
}

export default element => new Dropdown(element);
